import {VENDOR_LIST_PAGE_SIZE} from "../actions/fetch_vendor_list";

interface IVendorList {
    count: number;
    soldVendorsCount: number;
}

export const calculateVendorListMaxPage = (vendorList: IVendorList) => {
    const vendorCountSold = vendorList.soldVendorsCount;
    const maxPageVendor = vendorList.count ? Math.ceil(vendorList.count / VENDOR_LIST_PAGE_SIZE) : 1;
    const maxPageSoldVendor = vendorCountSold ? Math.ceil(vendorCountSold / VENDOR_LIST_PAGE_SIZE) : 0;
    // we show sold vendors only on listings shorter than 3 pages
    return maxPageVendor > 2 ? maxPageVendor : maxPageVendor + Math.max(0, (maxPageSoldVendor > 2 ? 2 : maxPageSoldVendor) - 1);
};
import {VENDOR_LIST_PAGE_SIZE} from "../actions/fetch_vendor_list";

interface IVendorList {
    count: number;
    soldVendorsCount: number;
}

export const calculateVendorListMaxPage = (vendorList: IVendorList) => {
    const vendorCountSold = vendorList.soldVendorsCount;
    const maxPageVendor = vendorList.count ? Math.ceil(vendorList.count / VENDOR_LIST_PAGE_SIZE) : 1;
    const maxPageSoldVendor = vendorCountSold ? Math.ceil(vendorCountSold / VENDOR_LIST_PAGE_SIZE) : 0;
    // we show sold vendors only on listings shorter than 3 pages
    return maxPageVendor > 2 ? maxPageVendor : maxPageVendor + Math.max(0, (maxPageSoldVendor > 2 ? 2 : maxPageSoldVendor) - 1);
};
